var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoPoker24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_poker24x24",
    transform: "translate(-2.786 -2.7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1742",
    d: "M10.12,10.342,9.179,4.723a1.107,1.107,0,0,1,.837-1.236l2.2-.45c0,.112-.1.337-.1.45L11.584,9.78c-.209,0-.418.112-.627.112A2.05,2.05,0,0,1,10.12,10.342Zm-2.3,1.911a4,4,0,0,1,1.569-1.461L8.447,4.948V4.273L6.042,5.4a1.193,1.193,0,0,0-.523,1.461ZM20.786,4.386l-.732,9.553a1.063,1.063,0,0,1-1.046,1.011l-2.614-.225-.209-.45c0-.112-.1-.225-.209-.337v-.45l-.209-1.011c0-.112-.1-.225-.209-.337v-.45l-.209-1.011a.468.468,0,0,0-.314-.45,3.48,3.48,0,0,0-2.614-.45l.523-6.069A1.063,1.063,0,0,1,13.989,2.7l5.856.562a1.082,1.082,0,0,1,.941,1.124ZM18.067,6.409a1.316,1.316,0,0,0-1.359.562,1.874,1.874,0,0,0-1.15-.9A1.378,1.378,0,0,0,14.3,7.308a2.2,2.2,0,0,0,.209.787c.314.562,1.882,2.585,1.882,2.585s1.882-1.686,2.3-2.135a1.32,1.32,0,0,0-.1-1.8C18.381,6.521,18.277,6.409,18.067,6.409Zm-9.2,11.014-.314-.9v-.45c-.1-.112-.1-.225-.209-.337l-.1-.562L4.892,7.42l-1.778,1.8a1.107,1.107,0,0,0-.1,1.461l5.856,6.968Zm3.346-2.7A3.653,3.653,0,0,1,8.97,14.5l.209,1.011a4.091,4.091,0,0,0,3.242.225,4.278,4.278,0,0,0,2.823-1.911l-.209-.9a4.554,4.554,0,0,1-2.823,1.8Zm2.3-3.709.209,1.011A3.927,3.927,0,0,1,11.9,13.939a3.653,3.653,0,0,1-3.242-.225L8.447,12.7a4.326,4.326,0,0,1,2.719-1.911,4.282,4.282,0,0,1,3.346.225Zm.941,3.484.209,1.011a3.927,3.927,0,0,1-2.823,1.911A3.653,3.653,0,0,1,9.6,17.2l-.314-.9a4.091,4.091,0,0,0,3.242.225A4.8,4.8,0,0,0,15.453,14.5Z",
    fill: "#999"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoPoker24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_poker24x24.cc07b1d9f7617cf322c832ec5d52ee7d.svg";